import styles from './style.module.scss';
import { Element } from 'react-scroll';
import { src } from '@/utils/common';
import FadeIn from '@/components/commonComponents/fadeIn';
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { WebPNextImage } from '../../WebPImage';

const FeatureCard = ({
  elementName = '',
  advantages,
  align = 'center',
  title = '核心优势',
  bgColor = '#fff',
  expand = false,
}) => {
  const itemRef = useRef(null);
  const btnRefs = useRef([]);
  const contentRefs = useRef([]);
  // 记录状态
  const [expandRefs, setExpandRefs] = useState(() => {
    const len = advantages.length;
    return new Array(len).fill(false);
  });
  const [matchRow, setMatchRow] = useState(-1);

  useEffect(() => {
    const len = advantages.length;
    btnRefs.current = btnRefs.current.slice(0, len);
    contentRefs.current = contentRefs.current.slice(0, len);
  }, [advantages]);

  const calRow = (index) => {
    return Math.ceil((index + 1) / 2);
  };

  const findTargetIndexs = (index, row, text) => {
    const recordIndexs = [index];
    for (let i = 0; i < btnRefs.current.length; i++) {
      if (calRow(i) === row || i === index) {
        recordIndexs.push(i);
      }
    }
    recordIndexs.map((item) => {
      btnRefs.current[`${item}`].innerText = text;
    });
  };

  const handleClick = (index) => {
    // 点击卡片：伸缩或扩展
    // 1. 更新记录对应卡片上的扩展状态  --- 决定样式UI
    // 2. 更新同行卡片样式（高度）
    const copyItem = [...expandRefs];
    copyItem[index] = !copyItem[index];
    setExpandRefs(copyItem);
    const row = calRow(index);
    setMatchRow(row);

    // 判断点击时是收起，还是扩展行为
    if (expandRefs[index]) {
      btnRefs.current[`${index}`].innerText = '展开全部';
    } else {
      btnRefs.current[`${index}`].innerText = '收起内容';
    }
  };

  return (
    <Element name={elementName}>
      <div className={styles.advantages} style={{ backgroundColor: bgColor }}>
        <FadeIn>
          <div
            className={classnames({
              [styles['title']]: true,
              [styles['title-expand']]: expand,
            })}
          >
            {title}
          </div>
        </FadeIn>
        <FadeIn cascade>
          <div
            className={classnames({
              [styles['items']]: true,
              [styles['items-expand']]: expand,
            })}
          >
            {advantages.map((item, index) => (
              <div
                key={index}
                ref={itemRef}
                className={classnames({
                  [styles['item-wrapper']]: true,
                  [styles['current-expand']]: expandRefs[index],
                })}
                style={{ alignItems: align }}
              >
                <WebPNextImage
                  src={item.picUrl || item.iconUrl}
                  width={64}
                  height={64}
                  className={styles.itemImg}
                  alt={item.title}
                />
                <div className={styles.itemTitle}>{item.title}</div>
                <span
                  className={styles.itemContent}
                  ref={(el) => (contentRefs.current[index] = el)}
                >
                  {item.content}
                </span>
                {!expand && item.content.length > 33 && (
                  <span
                    onClick={() => handleClick(index)}
                    ref={(el) => (btnRefs.current[index] = el)}
                    className={classnames({
                      [styles['item-btn']]: true,
                      [styles['expand-target']]: !!expandRefs[index],
                    })}
                  >
                    展开全部
                  </span>
                )}
              </div>
            ))}
          </div>
        </FadeIn>
      </div>
    </Element>
  );
};

export default FeatureCard;
